import { component } from 'picoapp'

export default component(({ node }) => {
  const faqs = node.querySelectorAll('li.faqs__faq')

  let active

  for (let i = 0; i < faqs.length; i++) {
    const id = faqs[i].id
    const [ a, p ] = faqs[i].children
    a.addEventListener('click', e => {
      e.preventDefault()

      window.history.pushState({}, '', e.target.href)

      console.log('faqs')
      active = id

      for (let i = 0; i < faqs.length; i++) {
        const faq = faqs[i]

        if (faq.id !== active) {
          faq.classList.add('is-inactive')
          faq.classList.remove('is-active')
        } else {
          if (faq.classList.contains('is-active')) {
            window.history.pushState({}, '', window.location.pathname)
            faq.classList.add('is-inactive')
            faq.classList.remove('is-active')
          } else {
            faq.classList.remove('is-inactive')
            faq.classList.add('is-active')
          }
        }
      }
    })
  }
})
